import { css } from '@emotion/core';
import { variables, mq } from '../../../cssInJs';

const numberOfTiles = [1, 2, 3, 3]
//const marginLR = [14, 14, 14, 14]
const marginTB = [14, 14, 14, 14]

const widthPercent = (index) => 100 / numberOfTiles[index] + '%'

const linkText = {
  color: variables.primaryColor,
  fontSize: '0.8rem',
  padding: '0 20px',
  // '&:hover': {
  //   color: variables.fontColor,
  // }
}

export const tileListStyle = {
  tiles: mq({
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: '0.6rem',
    //marginLeft: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    //marginRight: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    //maxWidth:['800px'],
    margin: 'auto'
  }),
  categoryList : mq({
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth:['800px'],
    margin: 'auto',
    'div.ff.form-group' : {
      maxWidth: '250px'
    }
  })
}

export const tileStyle = {
  tile: mq({
    //paddingLeft: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    //paddingRight: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    //paddingLeft : '10px',
    //paddingRight : '10px',
    //paddingTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    //paddingBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    //maxWidth: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    //flexBasis: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    maxWidth: [widthPercent(0), widthPercent(1), widthPercent(2), "33.33%"],
    flexBasis: [widthPercent(0), widthPercent(1), widthPercent(2), "33.33%"],
    flexGrow: 0,
    flexShrink: 0,
    // borderRadius : '20px',
    boxShadow: '1px 2px 10px rgb(190 190 190)',
    overflow: 'hidden',
    height: '600px',
  }),
  tileLink: {
    //background: variables.primaryColor,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    //padding: 5,
    //border: '1px solid red',
    '&:hover': {
      textDecoration: 'none',
      //background: '#f3f3f3'
      '& .product-image': {
        transform: 'scale(1.02)',
      }
    }
  },
  prdImage: {
    //padding: '0 5px',
    //maxWidth: '190px',
    //margin: 'auto',
    width: '100%',
    backgroundColor: '#f5f5f5',
    overflow: 'hidden',
  },
  bg: {
    //height: 0,
    //paddingBottom: '100%',
    //paddingTop: '210px',
    paddingTop: '341px',
    paddingBottom: '20px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    color:'black',
    transition: 'transform 0.3s ease',
  },
  shortDes : css({
    fontSize: '0.8rem',
    textAlign:'left',
    color:'black',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    padding: '0 20px',
    height: '60px', // 固定高度，约3行
    lineHeight: '1.4',
  }),
  name: css(linkText, {
    fontWeight: '700',
    fontFamily: variables.familyHeader,
    fontSize: '1.4rem',
    textAlign:'left',
    marginTop:'8px',
    marginBottom: '4px',
    textTransform: 'capitalize',
    color:'black',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    height: '65px', // 固定高度，约3行
    lineHeight: '1.4',
  }),
  price: css(linkText, {
    fontWeight: 'bold',
    textAlign:'left',
    marginBlock:'.8rem',
    color:'black',
    height: '30px', // 固定高度
    lineHeight: '1.2',
  }),
  buyNow: css({
    display: 'inline-block',
    fontSize: '0.8rem',
    width: '150px',
    textAlign: 'center',
    textTransform: 'uppercase',
    marginLeft: '20px',
    padding: '4px 12px',
    color: '#13aec2',
    border: '2px solid #13aec2',
    borderRadius: '20px',
    backgroundColor: 'transparent',
    position: 'absolute',
    bottom: '20px',
    left: '0',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: '#13aec2',
      color: '#fff'
    }
  })
}